import { appLabels, appNames } from "./app";

export const labelsByApp = Object.freeze({
    [appNames.XAM]: {
        headerLabel: appLabels[appNames.XAM],
    },
    [appNames.XBM]: {
        headerLabel: appLabels[appNames.XBM],
    },
});
